export default {
  methods: {
    goToModifiedPropertiesURL(propertyId, processFunc) {
      this.goToModifiedQueryUrl('p', propertyId, processFunc);
    },
    goToModifiedOptionsURL(optionId, processFunc) {
      this.goToModifiedQueryUrl('o', optionId, processFunc);
    },
    goToModifiedQueryUrl(scope, itemId, processFunc) {
      const newQuery = { ...this.$route.query || {}, page: 1 };
      const key = `${scope}_${itemId}`;
      let values = newQuery[key] ? newQuery[key].split(',') : [];
      values = processFunc(values);

      if (values.length === 0) {
        delete newQuery[key];
      } else {
        newQuery[key] = values.join(',');
      }

      this.$router.push({ query: newQuery });
    },
  },
};
